import WsProvider from './provider/WSProvider'

var bildirimService = {
    bildirimGonder(title, body, tur, id) {
        var param = {
            "to": "/topics/all",
            "notification": {
                "title": title,
                "body": body,
                "content_available": true,
                "priority": "high",
                "sound" : "default"
            },
            "data": {
                "tur": tur,
                "id": id
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPostMobil(param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    siparisGonder(to, body, tur, id) {
        var param = {
            "to": to,
            "notification": {
                "title": 'Sipariş Takibi',
                "body": body,
                "content_available": true,
                "priority": "high",
                "sound" : "default"
            },
            "data": {
                "tur": tur,
                "id": id
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPostMobil(param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

}

export default bildirimService

